/* 
import AppListing from '../app-components/Listing/AppListing';
import { BaseListing } from 'craftable'; 
*/
import FormMixin from '../app-components/Mixin';
// const PrintVue = 
Vue.component('print-vue', {
    /* 
    mixins: [AppListing],
    mixins: [BaseListing], 
    */
    mixins: [FormMixin],
    methods:{
        formatDate(dateString, originFormat, toFormat)
        {   
            
        }
    },
    mounted: function () {  
        console.log(this.dateFormat)
        console.log(this.formatDate)
    },
    /* 
    data: function () {  
    },
    render() {
    } 
    */
    template: `<div > <slot /> </div>`,
})
 

// export default PrintVue;